export const ANIMAL_LIST_URL = 'animal/list'
export const ANIMAL_LIST_ERROR = 'ANIMAL_LIST_ERROR'
export const ANIMAL_LIST_LOADING = 'ANIMAL_LIST_LOADING'
export const ANIMAL_LIST_SUCCESS = 'ANIMAL_LIST_SUCCESS'